import PubSub from "pubsub-js";
import React, { useEffect, useState } from "react";
import { CONSTANTS, MAINMENU, NOTIFY, PLATFORM, STATUS_ACTIVE } from "../../based/Constants";
import { ConfirmDialog } from "../../based/Dialog";
import CheckBox from "../../based/inputs/CheckBox";
import Loading from "../../based/Loading";
import { Notify } from "../../based/Notify";
import PlatformServices from "../../based/services/PlatformServices";

export default function ViettelInvoiceConfig(props) {
    const [isBusy, setBusy] = useState(true);
    const [message, setMessage] = useState("Đang tải dữ liệu...");
    const [stores, setStores] = useState([]);
    const [storeSelected, setStoreSelected] = useState(null);

    useEffect(() => {
        _getStores();
        PubSub.publish(CONSTANTS.SIDEBAR_MENU_TOPIC, { mainMenu: MAINMENU.ConnectPlatform });
    }, []);

    async function _handleConnectToPancake() {
        setBusy(true);
        setMessage("Đang kết nối...");
        const [err, data] = await PlatformServices.ConnectToPlatform(`?platform=${PLATFORM.ViettelInvoice}`);
        if (!err) {
            setBusy(false);
            setMessage("");
            _getStores();
        } else {
            setBusy(false);
            setMessage("");
        }
    }

    async function _getStores() {
        setBusy(true);
        setMessage("Đang tải dữ liệu..");
        const [err, data] = await PlatformServices.PlatformStoresUser([PLATFORM.ViettelInvoice], STATUS_ACTIVE.All);
        if (!err) {
            setStores(data);
            setBusy(false);
            setMessage("");
        } else {
            setBusy(false);
            setMessage("");
        }
    }

    async function _handleRemoveStore(store) {
        ConfirmDialog("Xác nhận", "Bạn chắc chắn muốn xóa kết nối đến gian hàng đã chọn? ", () => {
            return new Promise(async (resolve, reject) => {
                setBusy(true);
                setMessage("Đang xóa dữ liệu..");
                const [err, data] = await PlatformServices.DeleteConnectStore(store.id);
                if (!err) {
                    if (data) {
                        resolve({ title: "Thành công", msg: "Xóa kết nối gian hàng thành công" });
                        let storesUpdate = [...stores];
                        let idx = -1;
                        storesUpdate.map((item, i) => {
                            if (item.id == store.id) idx = i;
                        });
                        if (idx > -1) storesUpdate.splice(idx, 1);
                        setStores(storesUpdate);
                    } else {
                        reject(err);
                    }
                    setBusy(false);
                    setMessage("");
                } else {
                    Notify(NOTIFY.ERROR, "Lỗi", CONSTANTS.MSG_ERROR);
                    setBusy(false);
                    setMessage("");
                }
            });
        });
    }

    async function _handleActiveStore(platform, shop, isActive) {
        const [err, data] = await PlatformServices.UpdateSetIsActiveShop(platform, shop, isActive);
        if (!err) {
            Notify(NOTIFY.SUCCESS, "Thành công", "Cập nhật trạng thái gian hàng thành công");
            _getStores();
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", "Cập nhật trạng thái gian hàng thất bại");
        }
    }

    function _renderTable() {
        return stores && stores.length > 0 ? (
            <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12">
                    <h4 className="header-title">
                        <b>Page Pancake của bạn</b>
                    </h4>
                    <table className="tablesaw table mb-0 tablesaw-stack">
                        <thead>
                            <tr>
                                <th>Mã gian hàng</th>
                                <th>Gian hàng</th>
                                <th>Ngày kết nối</th>
                                <th>Hoạt động</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {stores.map((store, k) => {
                                return (
                                    <tr key={k} className={storeSelected && storeSelected.shopName == store.shopName ? "tr_selected" : ""}>
                                        <td>
                                            <strong className="store-name" onClick={() => setStoreSelected(store)}>
                                                {store.shopId}
                                            </strong>
                                        </td>
                                        <td>
                                            <strong className="store-name" onClick={() => setStoreSelected(store)}>
                                                {store.shopName} {store.sellerId ? ` (${store.sellerId})` : ""}
                                            </strong>
                                        </td>
                                        <td>
                                            <span>{store.connectDate}</span>
                                        </td>
                                        <td>
                                            <CheckBox
                                                name={`isActive_${store.id}`}
                                                checked={store.isActive}
                                                onCheckedChange={(name, value) => {
                                                    _handleActiveStore(PLATFORM.ViettelInvoice, store.shopId, value);
                                                }}
                                                label="Kích hoạt"
                                            />
                                        </td>
                                        <td>
                                            <button className="btn btn-danger btn-sm" onClick={() => _handleRemoveStore(store)}>
                                                <i className="fa fa-trash-o"></i>
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        ) : null;
    }
    return (
        <React.Fragment>
            <Loading show={isBusy} msg={message} />
            <div className="row">
                <div className="col-sm-12 form-row card-box p-3">
                    <div className="col-12 col-lg-8">
                        <div className="lazada-channel--text">
                            <p className="mb-3 font-size-24px header-title">
                                Kết nối Viettel Invoice
                                {stores && stores.length > 0 ? <span> ({stores.length})</span> : null}
                            </p>
                            {stores && stores.length > 0 ? (
                                <p className="sub-header text-success">
                                    <b>Hãy bắt đầu sử dụng.</b>
                                </p>
                            ) : (
                                <p className="sub-header text-danger">Vui lòng kết nối để bắt đầu sử dụng.</p>
                            )}
                        </div>
                        <div className="text-left">
                            <button className="btn btn-custom mt-3 mb-3" onClick={() => _handleConnectToPancake()}>
                                <span>
                                    <i className="fa fa-share-alt"></i> Kết nối kênh bán hàng
                                </span>
                            </button>
                        </div>
                        <hr />
                        {_renderTable()}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
